"use client";

import { hideErrorDialog } from "@/data/redux/appSlice";
import { useAppDispatch, useAppSelector } from "@/data/redux/store";
import OprDialog from "../controls/OprDialog";

export default function ErrorDialog() {
  const dispatch = useAppDispatch();
  const state = useAppSelector((state) => state.app.errorDialog);
  return (
    <OprDialog open={state.open} onClose={() => dispatch(hideErrorDialog())} title={state.title || "Error"}>
      <p>{state.message}</p>
    </OprDialog>
  );
}
